import isEmpty from "lodash/isEmpty";

import apiService from "src/services/api/apiService";
import notificationService from "src/services/notificationService";
import * as types from "./mutationTypes";

const logTag = "categoriesStore";


const moduleState = {
    category        : {},
    chapter         : {},
};

const moduleGetters = {
    category        : state => state.category,
    chapter         : state => state.chapter,
};

const actions = {
    emptyCategory({ commit }) {
        commit(types.REPLACE_CATEGORY, {});
    },

    downloadCategory({ commit }, categoryId) {
        return apiService.getCategoryDetails(categoryId).then(result => {
            commit(types.REPLACE_CATEGORY, result.data);
            return result.data;
        });
    },

    emptyChapter({ commit }) {
        commit(types.REPLACE_CHAPTER, {});
    },

    downloadChapter({ commit }, {categoryId, chapterId}) {
        return apiService.getChapter(categoryId, chapterId).then(result => {
            commit(types.REPLACE_CHAPTER, result.data);
            return result.data;
        });
    },

    answerTriviaQuestion({ commit, getters }, {questionId, answer}) {
        return apiService.answerTriviaQuestion(questionId, answer).then(result => {
            if (!isEmpty(result.data.achievements)) {
                notificationService.newAchievementsSingle(result.data.achievements, getters.currentAreaCssClass);
            }
            return result.data;
        });
    },

    chapterOpened({ commit }, {categoryId, chapterId}) {
        return apiService.chapterOpened(categoryId, chapterId).then(result => {
            return result.data;
        });
    },
};

const mutations = {
    [types.REPLACE_CATEGORY](state, newCategory) {
        state.category = newCategory;
    },

    [types.REPLACE_CHAPTER](state, newChapter) {
        state.chapter = newChapter;
    },
};

export default {
    state : moduleState,
    getters : moduleGetters,
    actions,
    mutations
};
